import { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { isRtlLanguage } from '../../lib/appHelpers';

// Ref URL: https://medium.com/@bloodyowl/the-provider-and-higher-order-component-patterns-with-react-d16ab2d1636  
class RTLProvider extends Component {
  static propTypes = {
    isRtl: PropTypes.bool
  }

  static defaultProps = {
    isRtl: isRtlLanguage(window.location.pathname.includes("/stem-literacy-programme") ? 'en' : localStorage.getItem('locale'))
  }

  static childContextTypes = {
    isRtl: PropTypes.bool
  }

  getChildContext() {
    const isRtl = isRtlLanguage(window.location.pathname.includes("/stem-literacy-programme") ? 'en' : localStorage.getItem('locale'))
    return { isRtl }
  }

  render() {
    // `Children.only` enables us not to add a <div /> for nothing
    return Children.only(this.props.children)
  }
}

export default RTLProvider;



// WEBPACK FOOTER //
// ./src/components/RTLProvider/RTLProvider.jsx